import { useEffect, useState } from 'react';

import { getEnv } from '@ctct/ctct-helpers';
import { trackAction } from '@ctct/distui-helpers';

import { BillingSvc } from '../api';
import { useCancelFlowContext } from '../CancelFlowContext';

const accountBillingTabURL = `https://app${getEnv()}constantcontact.com/pages/myaccount/settings/billing`;

// TODO: This hook is entirely unused currently, and will probably need
// to be chagned to use useCallback see OfferPromo.jsx for more context
export default function useApplyPromotion() {
  const [cancelFlowContext, cancelFlowReducer] = useCancelFlowContext();
  const [loading, setLoading] = useState(false);

  const {
    promoData: {
      isPromoApplied,
      content: { promoCode, username },
    },
  } = cancelFlowContext;

  useEffect(() => {
    if (!isPromoApplied && promoCode && username && !loading) {
      setLoading(true);

      const { setPromotion } = BillingSvc;
      // TODO: this was the old way of doing it, was it sufficent or is the new way better?
      // try {
      //   await setPromotion({ promoCode, username });
      //   setCancelPromoApplied(true);
      // } catch (err) {
      //   const { response } = err || {};
      //   const { data } = response || {};
      //   const [errorMessage] = Object.values(data);
      //   setCancelPromotionError(errorMessage);
      // }

      setPromotion({ promoCode, username })
        .then(() => {
          trackAction({ action: 'accepting cancel promo' });
          cancelFlowReducer({
            type: 'setPromoApplied',
            value: true,
          });
        })
        .catch((error) => {
          cancelFlowReducer({
            type: 'setPromoApplied',
            value: false,
          });

          // TODO: refactor this into destructure syntax
          const data = error?.response?.data;

          cancelFlowReducer({
            type: 'setPromoError',
            value: Object.values(data || {}),
          });
        })
        // TODO: this should probably just close the dialog instead of redirecting
        .finally(() => {
          window.location.href = accountBillingTabURL;
        });

      setLoading(false);
    }
  }, [isPromoApplied, promoCode, username, loading]);

  return isPromoApplied;
}
